import { Tooltip } from "@mui/material";
import { formatLocaleDateString } from "helpers/utils";
import { useTranslation } from "react-i18next";
import type { IArticle } from "store/articleStore";

import styles from "./style.module.scss";

interface ILastSentChip {
    article: IArticle;
}
/**
 * Last sent chip for articles/services table
 */
const LastSentChip = ({ article }: ILastSentChip) => {
    const [t] = useTranslation();
    return (
        <Tooltip
            title={`${
                article.contractSigned === 2 ? t("Articles.DocumentsLastSentAt") : t("Articles.StatementsLastSentAt")
            } ${formatLocaleDateString({
                date: article?.lastSentAt as Date,
                options: { numeric: true, timeZone: "UTC" },
            })}`}
        >
            <div className={styles["last-sent-chip"]}></div>
        </Tooltip>
    );
};

export default LastSentChip;
